module.exports = __webpack_public_path__ + "img/school360online.03b5f051.png";